import kr from 'Kr/kr';
import GLightbox from 'glightbox';
import HTMLClass from 'Kr/utils/HTMLClass';

export default class LayoutGallery extends kr.Component {
    init() {
        this._toRun = ['.js_gallery', '.wp-block-gallery'];
        this._countGallery = 0;
        this._run();
    }

    _run() {
        for (let i in this._toRun) {
            this._enableGalleryFor(this._toRun[i]);
        }
    }

    _enableGalleryFor(name) {
        const $el = this.$element.querySelectorAll(name);
        if ($el.length == 0) {
            return false;
        }

        for (let i in $el) {
            if ($el[i] == $el.length) return;
            this._countGallery++;
            HTMLClass.addClass($el[i], `js_gallery-${this._countGallery}`);


            new GLightbox({
                'selector': `.js_gallery-${this._countGallery} a`,
            });
        }
    }
}

kr.registerComponent('.web__root', {
    component: LayoutGallery
});